<template>
  <div class="alert alert-danger">
    <h3 class="title" v-html="title"></h3>
    <pre v-show="showDetails"> {{ details }} </pre>
    <a class="btn btn-primary" @click="hide()">Dölj</a>
    <!-- <a class="btn btn-primary"  v-if="!showDetails" @click="showDetails = true">Visa detaljer</a>
     <a class="btn btn-primary"  v-if="showDetails" @click="showDetails = false">Dölj detaljer</a> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { matchingErrorMessage } from "@/helpers";

export default {
  props: ["error"],

  data() {
    return {
      show: true,
    };
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
  },
  computed: {
    ...mapGetters(["webapp_config"]),

    title() {
      const matching = matchingErrorMessage(this.error);

      if (matching) return matching.text;
      else {
        // Borde inte hamna här men..visa generellt felmeddelande
        let description = "Något gick fel";
        //      let description = (this.error.response.data && this.error.response.data.description ? this.error.response.data.description : this.error.response.data);

        return description;
      }
    },

    /**
     * Man kan slå på och av ifall felmeddelandets detaljer ska skrivas ut.
     */
    showDetails() {
      return this.webapp_config.show_api_error_details;
    },

    details() {
      return {
        data: this.error.response.data,
        status: this.error.response.status,
        statusText: this.error.response.statusText,
      };
    },
  },

  created() {
    jQuery("html, body")
      .stop()
      .animate(
        {
          scrollTop: jQuery("#errors-list").offset().top - 70,
        },
        500
      );
  },
};
</script>
